"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = Text;
var _react = _interopRequireDefault(require("react"));
var _ = require("../..");
var _styled = require("../../styled");
var _animations = require("../../shared/animations");
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Main component
// -------------------------------------------------------------------------------------------------

/**
 * The `Text` component is base-level component that can be used to set fonts and font settings.
 */
function Text({
  children,
  className,
  color,
  css: cssProps,
  lineHeight,
  testId,
  ...props
}) {
  const propStyles = (0, _styled.css)({
    color,
    lineHeight
  });
  if (typeof children === 'number') children = children.toLocaleString();
  return /*#__PURE__*/_react.default.createElement(_styled2.StyledText, _extends({
    className: `${propStyles()} ${className}`,
    css: cssProps,
    "data-testid": testId
  }, props), children);
}

//
// Font components
// -------------------------------------------------------------------------------------------------

Text.Lato = Lato;
/**
 * `Text.Lato` is a convenience component for setting the font to _"Lato"_ of the given text.
 */
function Lato({
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(Text, _extends({
    font: "lato"
  }, props));
}
Text.Roboto = Roboto;
/**
 * `Text.Roboto` is a convenience component for setting the font to _"Roboto"_ of the given text.
 */
function Roboto({
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(Text, _extends({
    font: "roboto"
  }, props));
}
Text.RobotoMono = RobotoMono;
/**
 * `Text.Roboto` is a convenience component for setting the font to _"Roboto"_ of the given text.
 */
function RobotoMono({
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(Text, _extends({
    font: "robotoMono"
  }, props));
}

//
// Text style defintions
// -------------------------------------------------------------------------------------------------
const Styles = {
  Title: {
    color: '$gray600',
    font: 'sans',
    size: 'sm',
    stretch: 'ultraCondensed',
    transform: 'uppercase',
    weight: 'medium'
  }
};
Text.Styles = Styles;

//
// Components for text styles
// -------------------------------------------------------------------------------------------------

Text.Title = Title;

/**
 * Utility component for implementing text with `Text.Styles.Title` styling.
 */
function Title({
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(Text, _extends({}, Styles.Title, props));
}

//
// Utility components
// -------------------------------------------------------------------------------------------------

Text.Loadable = Loadable;
function Loadable({
  children,
  loading,
  placeholder,
  ...props
}) {
  const isLoading = (0, _.useLoadable)(loading);
  if (!isLoading) return /*#__PURE__*/_react.default.createElement(Text, props, children);
  return /*#__PURE__*/_react.default.createElement(Text, _extends({}, props, {
    color: "$gray400",
    css: {
      animation: `${_animations.pulse} 1.5s linear infinite`,
      userSelect: 'none'
    }
  }), placeholder !== null && placeholder !== void 0 ? placeholder : children);
}